// 用户相关请求

import { message } from "antd";
import { request } from "../utils";


export function loginAPI(FormData) {
  return request({
    url: "/admin/manager/login",
    method: "POST",
    data: { username: FormData.username, password: FormData.password },
  }).then((res)=>{
    // 启动定时器，每隔 60 秒检查一次 Token
    console.log(res.data.message)
    message.success('登录成功')
    return res
  }).catch((err)=>{
    console.log(err)
    message.error(`登录失败：${err.message}`)
  });
}
export function logoutAPI(){
  return request({
    url:'/admin/manager/logout',
    method:'POST'
  }).then((res)=>{
    message.success('退出登录成功')
  }).catch((err)=>{
    message.error(`退出登录失败：${err.message}`)
  });
}

export function getProfileAPI() {
  return request({
    url: "/admin/user/profile",
    method: "GET",
  });
}
